export const BUILD_NUMBER = '547ebf'; export const SEQUENTIAL_BUILD_NUMBER = '1205'; export const PACKAGE_VERSION = '3.0.10';export const SELECTED_THEME = 'smartcr';
